import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { MapLocation } from './MapLocation';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';

interface IAddresses {
  addresses: {
    firstAddress: IAddress;
    secondAddress: IAddress;
  };
  coordinates: {
    firstLatitude: number | undefined;
    firstLongitude: number | undefined;
    secondLatitude: number | undefined;
    secondLongitude: number | undefined;
  };
}

export interface IAddress {
  street: string;
  houseNumber: string;
  cityId: number | undefined;
}

export const Address = ({ addresses, coordinates }: IAddresses) => {
  const { findCity } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .therapy;

  const { firstLatitude, firstLongitude, secondLatitude, secondLongitude } =
    coordinates;

  return (
    <Stack gap='8px'>
      {addresses.firstAddress.street || addresses.secondAddress.street ? (
        <>
          {addresses.firstAddress.street && (
            <Stack
              direction={isDesktop ? 'column' : 'row'}
              gap={isDesktop ? '4px' : '8px'}
            >
              {isDesktop && (
                <Typography
                  variant='body5'
                  component='h4'
                  sx={{
                    width: 'fit-content',
                    cursor: 'text',
                  }}
                >
                  {dictionary.address}
                </Typography>
              )}
              <Typography
                variant='body3'
                sx={{
                  width: 'fit-content',
                  cursor: 'text',
                }}
              >
                {addresses.firstAddress.street}{' '}
                {addresses.firstAddress.houseNumber || ''}
                {findCity(addresses.firstAddress.cityId)}
              </Typography>
              {firstLatitude !== undefined && firstLongitude !== undefined && (
                <MapLocation
                  latitude={firstLatitude}
                  longitude={firstLongitude}
                />
              )}
            </Stack>
          )}

          {addresses.secondAddress.street && (
            <>
              <Typography
                variant='body5'
                component='h4'
                sx={{
                  width: 'fit-content',
                  cursor: 'text',
                }}
              >
                {addresses.firstAddress.street
                  ? dictionary.extraAddress
                  : dictionary.address}
              </Typography>

              <Stack
                direction={isDesktop ? 'column' : 'row'}
                gap={isDesktop ? '4px' : '8px'}
              >
                <Typography
                  variant='body3'
                  sx={{
                    width: 'fit-content',
                    cursor: 'text',
                  }}
                >
                  {addresses.secondAddress.street}{' '}
                  {addresses.secondAddress.houseNumber || ''}
                  {findCity(addresses.secondAddress.cityId)}
                </Typography>
                {secondLatitude !== undefined &&
                  secondLongitude !== undefined && (
                    <MapLocation
                      latitude={secondLatitude}
                      longitude={secondLongitude}
                    />
                  )}
              </Stack>
            </>
          )}
        </>
      ) : (
        <Typography
          variant='body3'
          sx={{
            width: 'fit-content',
            cursor: 'text',
          }}
        >
          {isDesktop ? dictionary.noData : dictionary.noAddress}
        </Typography>
      )}
    </Stack>
  );
};
